import { render } from "./Sidebar.vue?vue&type=template&id=74113be0"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=74113be0&lang=postcss"

import exportComponent from "/home/jenkins/agent/workspace/sd-app-pipe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__